import { render } from "./WaysSection.vue?vue&type=template&id=318ca1fd&scoped=true"
import script from "./WaysSection.vue?vue&type=script&lang=js"
export * from "./WaysSection.vue?vue&type=script&lang=js"

import "./WaysSection.vue?vue&type=style&index=0&id=318ca1fd&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-318ca1fd"]])

export default __exports__